import styled from "styled-components";

const FranceInvestmentWrapper = styled.section`
  width: 100%;
  padding: 50px 15px;
  background: linear-gradient(45deg, #cce7ff, #e3f2fd);
  box-sizing: border-box;
`;

const FranceInvestmentContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 25px;
`;

const FranceInvestmentInfo = styled.div`
  flex: 1;
  min-width: 250px;
  text-align: center;
`;

const FranceInvestmentImage = styled.img`
    max-width: 100%;
    border-radius: 12px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
`;

const FranceInvestmentText = styled.div`
    flex: 1;
    min-width: 250px;
`;

const FranceInvestmentHeader = styled.h2`
    font-size: 32px;
    color: #0073e6;
    margin-bottom: 15px;
    font-weight: bold;
`;

const FranceInvestmentParagraph = styled.p`
    font-size: 16px;
    color: #4a4a4a;
    line-height: 1.6;
    margin-bottom: 15px;
`;

const About = () => {
  return (
    <FranceInvestmentWrapper>
      <FranceInvestmentContainer>
        <FranceInvestmentText>
          <FranceInvestmentHeader>À Propos de France Investment</FranceInvestmentHeader>
          <FranceInvestmentParagraph>
            Chez France Investment, nous nous consacrons à promouvoir la littératie financière et à préparer l'avenir grâce à l'éducation économique. Notre plateforme en ligne permet le développement de compétences et d'une pensée à long terme.
          </FranceInvestmentParagraph>
          <FranceInvestmentParagraph>
            Rejoignez notre communauté pour explorer des opportunités de croissance personnelle et assurer votre sécurité financière. Ensemble, nous bâtissons un avenir stable et prospère dans l'économie moderne.
          </FranceInvestmentParagraph>
        </FranceInvestmentText>
      </FranceInvestmentContainer>
    </FranceInvestmentWrapper>
  );
};
export default About;